export function titleCase(string: any) {
  const arrayString = string.split(' ');
  let capitalizedWord = '';
  arrayString.map((word: string) => {
    const str = word.charAt(0).toUpperCase();
    const str2 = word.slice(1);
    const strCapitalized = str.concat(str2);
    capitalizedWord = capitalizedWord.concat(" ",strCapitalized);
  });
  return capitalizedWord.trim();
}
